/* eslint-disable react/prop-types */
import React from 'react'
import { isGwsDirectoryEmployee } from '../../../../../util/employeeLicenses.util'
import IdentityContact from './IdentityContactCard'
import JobInformation from './JobInformationCard'

function UserProperties(props) {
  const { employee, intl, employeeEmailOptions = [], isIntegrated = true } = props
  const isGws = isGwsDirectoryEmployee(employee)
  const isEmailEditable = isIntegrated ? !employee?.onPremisesSyncEnabled : true

  return (
    <div className="section px-4 py-4">
      <IdentityContact
        employee={employee}
        intl={intl}
        isIntegrated={isIntegrated}
        isEmailEditable={isEmailEditable}
        isGws={isGws}
      />
      <hr className="mb-3" />
      <JobInformation
        employee={employee}
        intl={intl}
        employeeEmailOptions={employeeEmailOptions}
        showOnlyBasicFields={!isIntegrated}
        isGws={isGws}
      />
    </div>
  )
}

export default UserProperties
